import { animate, style, transition, trigger } from "@angular/animations";

export const SLIDE_UP_DOWN = trigger('SlideUpDown', [
    transition(':enter', [
        style({
            height: 0,
            opacity: 0
        }),
        animate('0.16s ease-out',
            style({
                height: '*',
                opacity: 1
            })
        )
    ]),
    transition(':leave', [
        style({
            height: '*',
            opacity: 1
        }),
        animate('0.16s ease-out',
            style({
                height: 0,
                opacity: 0
            })
        )
    ])
]);